/**
 * Who on the team is emailed about every new ticket and every customer reply.
 */

import React, { useEffect, useState } from 'react';
import { authFetch } from '../../utils/api';

export default function TeamNotifications({ team, emailConfigured, onSaved }) {
  const [people, setPeople] = useState([]);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setPeople((team && team.people) || []);
  }, [team]);

  function change(index, field, value) {
    setPeople((rows) => rows.map((row, at) => (at === index ? { ...row, [field]: value } : row)));
    setStatus('');
  }

  function addRow() {
    setPeople((rows) => [...rows, { name: '', email: '' }]);
    setStatus('');
  }

  function removeRow(index) {
    setPeople((rows) => rows.filter((row, at) => at !== index));
    setStatus('');
  }

  async function save(event) {
    event.preventDefault();
    setError('');
    setStatus('');
    const res = await authFetch('/api/tickets/settings/team', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ people }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      setError(data.error || 'Could not save the team list.');
      return;
    }
    setPeople(data.people || []);
    setStatus('Saved.');
    if (onSaved) onSaved();
  }

  return (
    <form className="support-form rf-card rf-card-body" onSubmit={save}>
      <h2>Team notifications</h2>
      <p className="support-meta">
        Everyone here is emailed about every new ticket and every customer reply, from the website, email, Fleet and the CNC app.
        They can reply from Outlook and the answer goes to the customer.
      </p>
      {!emailConfigured && <p className="support-error">Email is not connected yet, so nobody is emailed.</p>}
      {people.length === 0 && <p className="support-error">Nobody is on the list. The team is not emailed about new tickets.</p>}
      {people.map((person, index) => (
        <div key={index} className="support-filters">
          <input
            className="rf-input"
            aria-label="Name"
            placeholder="Name"
            value={person.name}
            onChange={(event) => change(index, 'name', event.target.value)}
          />
          <input
            className="rf-input"
            aria-label="Email"
            type="email"
            placeholder="name@rapidfusion.co.uk"
            required
            value={person.email}
            onChange={(event) => change(index, 'email', event.target.value)}
          />
          <button type="button" className="rf-btn rf-btn-outline" onClick={() => removeRow(index)}>Remove</button>
        </div>
      ))}
      {error && <p className="support-error">{error}</p>}
      {status && <p className="support-meta">{status}</p>}
      <div className="support-filters">
        <button type="button" className="rf-btn rf-btn-secondary" onClick={addRow}>Add person</button>
        <button type="submit" className="rf-btn rf-btn-primary">Save team</button>
      </div>
    </form>
  );
}
